document.addEventListener("DOMContentLoaded", function () {
    const leftContent = document.querySelector(".left-content");
    const rightContent = document.querySelector(".right-content");
    if (!leftContent || !rightContent) return;
    
    const sections = leftContent.querySelectorAll("section");
    // CREATE ACCORDION CONTAINER
    const accordionContainer = document.createElement("div");
    accordionContainer.classList.add("accordion");

    // GROUP SECTIONS BY "Title"
    // Example: "Look Book 2025" → inside multiple sections
    const group = {};
    sections.forEach(section => {
        // Auto-generate ID if missing
        if (!section.id) {
            section.id = section.querySelector("h2")
                .textContent
                .toLowerCase()
                .replace(/\s+/g, "-");
        }

        // MAIN COLLECTION TITLE (top heading inside .left-content)
        const wrapper = section.closest(".look-book-content-wrapper");
        const mainTitle = wrapper?.querySelector(".page-title")?.textContent.trim() || "Look Book";


        if (!group[mainTitle]) group[mainTitle] = [];

        const childTitle = section.querySelector("h2")?.textContent?.trim();
        group[mainTitle].push({
            id: section.id,
            childTitle
        });
    });

    // BUILD ACCORDION HTML
    Object.keys(group).forEach(mainTitle => {
        const accordionItem = document.createElement("div");
        accordionItem.classList.add("accordion-item");

        accordionItem.innerHTML = `
            <div class="accordion-header" data-title="${mainTitle}">
                ${mainTitle}
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f"><path d="M480-345 240-585l56-56 184 183 184-183 56 56-240 240Z"/></svg>
            </div>
            <div class="accordion-body">
                ${group[mainTitle].map(item => `
                    <div class="accordion-link" data-target="${item.id}">
                        ${item.childTitle}
                    </div>
                `).join("")}
            </div>
        `;

        accordionContainer.appendChild(accordionItem);
    });

    // APPEND INTO RIGHT CONTENT
    rightContent.appendChild(accordionContainer);

    // ACCORDION TOGGLE
    document.querySelectorAll(".accordion-header").forEach(header => {
        header.addEventListener("click", () => {
            header.classList.toggle("active");
            header.nextElementSibling.classList.toggle("open");
        });
    });

    // SCROLL TO TARGET SECTION
    /*
    document.querySelectorAll(".accordion-link").forEach(link => {
        link.addEventListener("click", () => {
            const targetId = link.getAttribute("data-target");
            const target = document.getElementById(targetId);

            if (target) {
                window.scrollTo({
                    top: target.offsetTop - 100,
                    behavior: "smooth"
                });
            }
        });
    });
    */

    document.querySelectorAll(".accordion-link").forEach(link => {
        link.addEventListener("click", () => {
            const targetId = link.dataset.target;
            const target = document.getElementById(targetId);
            if (!target) return;

            const headerOffset = 120; // adjust if you have sticky header
            const elementPosition = target.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        });
    });
    
});

document.addEventListener("DOMContentLoaded", function () {

    // =============================================
    // BASIC ACCORDION CLICK HANDLING
    // =============================================

    const accordionHeaders = document.querySelectorAll(".accordion-header");
    const allContentBlocks = document.querySelectorAll(".look-book-content-wrapper");
    const accordionItems = document.querySelectorAll(".accordion-item");
    const contents = document.querySelectorAll(".look-book-content-wrapper");

    let activeIndex = 0;

    // Click on accordion header (switch lookbook year)
    accordionHeaders.forEach(header => {
        header.addEventListener("click", () => {
            const index = [...accordionHeaders].indexOf(header);
            openAccordion(index);
        });
    });

    // =============================================
    // DEFAULT ACTIVE ON PAGE LOAD
    // =============================================
    let isInitialLoad = true;

    function openAccordion(index) {
        activeIndex = index;

        accordionItems.forEach((item, i) => {
            item.classList.toggle("active", i === index);
        });

        contents.forEach((c, i) => {
            c.classList.toggle("active", i === index);
        });

        const newTitle =
            accordionItems[index].querySelector(".accordion-header").dataset.title;

        document.getElementById("pageTitle").innerText = newTitle;

        updateButtons();
        // -----------------------------------------
        // SCROLL TO TOP OF LEFT CONTENT (FIX)
        // -----------------------------------------
        if (!isInitialLoad) {
            const leftBlock = document.querySelector(".left-content");
            if (leftBlock) {
                window.scrollTo({
                    top: leftBlock.offsetTop - 80,
                    behavior: "smooth"
                });
            }
        }
        isInitialLoad = false;
    }

    // Open first accordion by default
    openAccordion(0);

    // =============================================
    // NEXT / PREVIOUS BUTTON NAVIGATION
    // =============================================

    function updateButtons() {
        const prev = document.getElementById("prevBtn");
        const next = document.getElementById("nextBtn");

        // ----- Previous button -----
        if (activeIndex > 0) {
            const prevTitle =
                accordionItems[activeIndex - 1].querySelector(".accordion-header").dataset.title;

            prev.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px">
                    <path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/>
                </svg>
                ${prevTitle}
            `;
            prev.disabled = false;

        } else {
            const prevTitle =
                accordionItems[0].querySelector(".accordion-header").dataset.title;

            prev.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px">
                    <path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/>
                </svg>
                ${prevTitle}
            `;
            prev.disabled = true;
        }

        // ----- Next button -----
        if (activeIndex < accordionItems.length - 1) {
            const nextTitle =
                accordionItems[activeIndex + 1].querySelector(".accordion-header").dataset.title;

            next.innerHTML = `
                ${nextTitle}
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px">
                    <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/>
                </svg>
            `;
            next.disabled = false;

        } else {
            const nextTitle =
                accordionItems[activeIndex].querySelector(".accordion-header").dataset.title;

            next.innerHTML = `
                ${nextTitle}
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px">
                    <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/>
                </svg>
            `;
            next.disabled = true;
        }
    }

    // NEXT button
    document.getElementById("nextBtn").addEventListener("click", function () {
        if (activeIndex < accordionItems.length - 1) {
            openAccordion(activeIndex + 1);
        }
    });

    // PREVIOUS button
    document.getElementById("prevBtn").addEventListener("click", function () {
        if (activeIndex > 0) {
            openAccordion(activeIndex - 1);
        }
    });

});
